import axios from 'axios';
import { objectToQueryString, mergeObject } from './utils';

export const r = async (input) => {
    const requestHeaders = {
        'Content-Type': 'application/json',
        //Accept: 'text/html,application/json,application/xhtml+xml,application/xml; q=0.9,*/*;q=0.8',
        //Accept: 'application/json',
        Accept: '*/*',
    };

    let {
        endpoint = '',
        method = 'get',
        data = {},
        headers = {},
        sessionToken = '',
        responseType = 'json',
        timeout = 14000,
    } = input;

    if (typeof sessionToken === 'string' && sessionToken.length > 0) {
        requestHeaders.Authorization = `Bearer ${sessionToken}`;
    }
    headers = mergeObject(requestHeaders, headers);

    try {
        let result = {};
        if (method === 'get') {
            const sendDataUrl = Object.keys(data).length > 0 ? `?${objectToQueryString(data)}` : '';
            result = await axios.get(`${endpoint}${sendDataUrl}`, {
                headers: headers,
                responseType: responseType,
                signal: abortSignal(timeout),
            });
        } else if (method === 'delete') {
            result = await axios.delete(`${endpoint}`, {
                headers: {
                    Authorization: `Bearer ${sessionToken}`,
                },
                responseType: responseType,
                signal: abortSignal(timeout),
            });
        } else {
            result = await axios[method](`${endpoint}`, data, {
                headers: headers,
                responseType: responseType,
                signal: abortSignal(timeout),
            });
        }
        const responseStatus = result.status;
        const o = await result.data;
        const allowedResponseStatuses = {
            200: 'OK',
            201: 'Created',
            202: 'Accepted',
            204: 'No Content',
        };
        if (responseStatus in allowedResponseStatuses) {
            //console.log(`useApi.js: request success, method ${method}, url ${endpoint}`, o);
            return o;
        }
        return false;
    } catch (e) {
        console.log(`useApi.js: request error, method ${method}, url ${endpoint}`, {
            data: data,
            headers: headers,
            error: e,
        });
        return false;
    }
};

const abortSignal = (timeoutMs) => {
    if (typeof globalThis.AbortController !== 'function') {
        return undefined;
    }
    const abortController = new globalThis.AbortController();
    setTimeout(() => abortController.abort(), timeoutMs || 0);
    return abortController.signal;
};
export const useApi = () => {
    return {
        r: r,
    };
};

export default useApi;
